__turbopack_context__.v({
  "arrow": "style-module-scss-module__ax5kNW__arrow",
  "component": "style-module-scss-module__ax5kNW__component",
  "item": "style-module-scss-module__ax5kNW__item",
  "layout-container": "style-module-scss-module__ax5kNW__layout-container",
});
